/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Stat_ResumesInputs */

const en_dashboard_stat_resumes = /** @type {(inputs: Dashboard_Stat_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumes`)
};

const de_dashboard_stat_resumes = /** @type {(inputs: Dashboard_Stat_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebensläufe`)
};

const fr_dashboard_stat_resumes = /** @type {(inputs: Dashboard_Stat_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const es_dashboard_stat_resumes = /** @type {(inputs: Dashboard_Stat_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currículums`)
};

const it_dashboard_stat_resumes = /** @type {(inputs: Dashboard_Stat_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curriculum Vitae`)
};

const nl_dashboard_stat_resumes = /** @type {(inputs: Dashboard_Stat_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV's`)
};

const pl_dashboard_stat_resumes = /** @type {(inputs: Dashboard_Stat_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

const fi_dashboard_stat_resumes = /** @type {(inputs: Dashboard_Stat_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansiotodistukset`)
};

const da_dashboard_stat_resumes = /** @type {(inputs: Dashboard_Stat_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV'er`)
};

const sv_dashboard_stat_resumes = /** @type {(inputs: Dashboard_Stat_ResumesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV`)
};

/**
* | output |
* | --- |
* | "Resumes" |
*
* @param {Dashboard_Stat_ResumesInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_stat_resumes = /** @type {((inputs?: Dashboard_Stat_ResumesInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stat_ResumesInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_stat_resumes(inputs)
	if (locale === "fr") return fr_dashboard_stat_resumes(inputs)
	if (locale === "es") return es_dashboard_stat_resumes(inputs)
	if (locale === "it") return it_dashboard_stat_resumes(inputs)
	if (locale === "nl") return nl_dashboard_stat_resumes(inputs)
	if (locale === "pl") return pl_dashboard_stat_resumes(inputs)
	if (locale === "fi") return fi_dashboard_stat_resumes(inputs)
	if (locale === "da") return da_dashboard_stat_resumes(inputs)
	if (locale === "sv") return sv_dashboard_stat_resumes(inputs)
	return en_dashboard_stat_resumes(inputs)
});